// Поля формы редактирования компании и поля самой компании, с которыми они сравниваются.
const FIELDS = [
  ['name', 'name'],
  ['generalArea', 'generalArea'],
  ['director', 'director'],
  ['phoneNumber', 'phoneNumber'],
  ['state', 'state'],
  ['region', 'region'],
  ['city', 'city'],
  ['companyType', 'type'],
];

// Пустое значение компании (null) и пустое поле формы ('') — одно и то же; число из компании
// и текст из поля сравниваются как текст.
const text = (value) => (value === null || value === undefined ? '' : String(value));

// Изменил ли человек что-то в форме по сравнению с компанией, с которой её открыли.
export const companyChanged = (form, company) =>
  FIELDS.some(([field, companyField]) => text(form[field]) !== text(company[companyField]));
